export enum ContentHeaderKey {
    Dashboard = "Dashboard",
    ProfileMember = "ProfileMember",
    ProfileDependents = "ProfileDependents",
    BenefitsCurrentBenefits = "BenefitsCurrentBenefits",
    BenefitsEnrollmentRequests = "BenefitsEnrollmentRequests",
    BenefitsBenefitsAtRenewal = "BenefitsBenefitsAtRenewal",
    BenefitsPendingEoi = "BenefitsPendingEoi",
    Beneficiaries = "Beneficiaries",
    DocumentsBenefits = "DocumentsBenefits",
    DocumentsCompany = "DocumentsCompany",
    DocumentsCompliance = "DocumentsCompliance",
    DocumentsContacts = "DocumentsContacts",
    DocumentsForm1095 = "DocumentsForm1095",
    DocumentsW2 = "DocumentsW2",
    Enrollment = "Enrollment",
    EnrollmentDashboardX = "EnrollmentDashboardX",
    EnrollmentDashboardXAddBenefit = "EnrollmentDashboardXAddBenefit",
    EnrollmentDashboardXReplaceBenefit = "EnrollmentDashboardXReplaceBenefit",
    EnrollmentDashboardXModifyBenefit = "EnrollmentDashboardXModifyBenefit",
    EnrollmentDashboardXWaiveBenefit = "EnrollmentDashboardXWaiveBenefit",
    EnrollmentDashboardXKeepCurrentElections = "EnrollmentDashboardXKeepCurrentElections",
    EnrollmentDashboardXCancelRequest = "EnrollmentDashboardXCancelRequest",
    CounselorCarrierInfo = "CounselorCarrierInfo",
    CounselorEditAgents = "CounselorEditAgents",
    CustomerRelationsMemberActivityLogDetail = "CustomerRelationsMemberActivityLogDetail",
    CustomerRelationsMemberActivityLogHistory = "CustomerRelationsMemberActivityLogHistory",
    CustomerRelationsMemberFollowUpOpen = "CustomerRelationsMemberFollowUpOpen",
    EnrollmentDashboardXTermBenefit = "EnrollmentDashboardXTermBenefit",
    EnrollmentDashboardXFsaReenroll = "EnrollmentDashboardXFsaReenroll",
    EnrollmentDashboardXWidget = "EnrollmentDashboardXWidget",
    EnrollmentDashboardCheckout = "EnrollmentDashboardCheckout",
    EnrollmentDashboardXWaiveCoverage = "EnrollmentDashboardXWaiveCoverage",
    CheckoutComplete = "CheckoutComplete",
    DependentVerification = "DependentVerification",
    LifeEventVerification = "LifeEventVerification",
    CheckoutCompleteNewhire = "CheckoutCompleteNewhire",
    ChekcoutCompleteYearround = "ChekcoutCompleteYearround",
    BenefitsBenefitSummary = "BenefitsBenefitSummary",
    CounselorMemberConfirm = "CounselorMemberConfirm",
    CounselorCallLog = "CounselorCallLog",
    CounselorCallLogDetail = "CounselorCallLogDetail",
    CounselorReports = "CounselorReports",
    CounselorCompanyResources = "CounselorCompanyResources",
    CounselorCustomerRelationsMemberActivityLogHistory = "CounselorCustomerRelationsMemberActivityLogHistory",
    CounselorCustomerRelationsMemberActivityLogDetail = "CounselorCustomerRelationsMemberActivityLogDetail",
    CounselorMemberLookup = "CounselorMemberLookup",
    CounselorLookupHistory = "CounselorLookupHistory",
    CounselorTestMembers = "CounselorTestMembers",
    CounselorCreateMember = "CounselorCreateMember",
    CounselorFollowUps = "CounselorFollowUps",
    CounselorFollowUpDetail = "CounselorFollowUpDetail",
    CounselorCustomerRelationsMemberFollowUpDetail = "CounselorCustomerRelationsMemberFollowUpDetail",
    CounselorCompletedFollowUps = "CounselorCompletedFollowUps",
    CounselorFollowUpManagement = "CounselorFollowUpManagement",
    MemberAccountingAccountTransactions = "MemberAccountingAccountTransactions",
    MemberAccountingBenefitTransactions = "MemberAccountingBenefitTransactions",
    CounselorCustomerRelationsMemberFollowUpOpen = "CounselorCustomerRelationsMemberFollowUpOpen",
    CounselorCustomerRelationsMemberFollowUpCompleted = "CounselorCustomerRelationsMemberFollowUpCompleted",
    CounselorCustomerRelationsMemberFollowUpManagement = "CounselorCustomerRelationsMemberFollowUpManagement",
    CounselorReportBuilderX = "CounselorReportBuilderX",
    WidgetAddDependent = "WidgetAddDependent",
    CounselorBenefitLevel = "CounselorBenefitLevel",
    CounselorCompanyLevel = "CounselorCompanyLevel",
    CounselorCompliance = "CounselorCompliance",
    CustomerRelationsMemberFollowUpCompleted = "CustomerRelationsMemberFollowUpCompleted",
    CustomerRelationsMemberFollowUpDetail = "CustomerRelationsMemberFollowUpDetail",
    ProfileDeleteMember = "ProfileDeleteMember",
    CounselorContacts = "CounselorContacts",
    EnrollmentPendingEoi = "EnrollmentPendingEoi",
    EnrollmentBenefitSummary = "EnrollmentBenefitSummary",
    EnrollmentDependentVerification = "EnrollmentDependentVerification",
    EnrollmentBeneficiaries = "EnrollmentBeneficiaries",
    EnrollmentAvailableEnrollments = "EnrollmentAvailableEnrollments",
    EnrollmentBenefitsDashboard = "EnrollmentBenefitsDashboard",
    EnrollmentCurrentAndPendingBenefits = "EnrollmentCurrentAndPendingBenefits",
    EnrollmentBenefitRequests = "EnrollmentBenefitRequests",
    EnrollmentLifeEventRequest = "EnrollmentLifeEventRequest",
    EnrollmentLifeEventRequestNotes = "EnrollmentLifeEventRequestNotes",
    CounselorReportsTodaysReports = "CounselorReportsTodaysReports",
    CounselorReportsHistory = "CounselorReportsHistory",
    CounselorManageAgents = "CounselorManageAgents",
    CounselorCompanyAssign = "CounselorCompanyAssign",
    CounselorAgentAssign = "CounselorAgentAssign",
    PaymentInformation = "PaymentInformation",
    AccountTransactions = "AccountTransactions",
    PayrollAddress = "PayrollAddress",
    PayrollDeductions = "PayrollDeductions",
    PayrollStateTaxDetails = "PayrollStateTaxDetails",
    PayrollFederalTaxDetails = "PayrollFederalTaxDetails",
    PayrollPTOSickHours = "PayrollPTOSickHours",
    PayrollAnnualStatements = "PayrollAnnualStatements",
    PayrollPayStubs = "PayrollPayStubs",
    PayrollDirectDeposit = "PayrollDirectDeposit",
    PayrollDashboard = "PayrollDashboard",
    AvailableBenefits = "AvailableBenefits"
}

// export enum ContentHeaderOldPaths {
//     contentHeaderDashboard = "dashboard",
//     Dashboard = "dashboard",
//     ProfileMember = "profile/member",
//     ProfileDependents = "profile/dependents",
//     BenefitsCurrentBenefits = "benefits/current-benefits",
//     BenefitsEnrollmentRequests = "benefits/enrollment-requests",
//     BenefitsBenefitsAtRenewal = "benefits/benefits-at-renewal",
//     BenefitsPendingEoi = "benefits/pending-eoi",
//     Beneficiaries = "beneficiaries",
//     DocumentsBenefits = "resources/benefit",
//     DocumentsCompany = "resources/company",
//     DocumentsCompliance = "resources/compliance",
//     DocumentsContacts = "resources/contacts",
//     Enrollment = "enrollment",
//     EnrollmentDashboardX = "enrollment-dashboard/x",
//     EnrollmentDashboardXAddBenefit = "enrollment-dashboard/x/add-benefit",
//     EnrollmentDashboardXReplaceBenefit = "enrollment-dashboard/x/replace-benefit",
//     EnrollmentDashboardXModifyBenefit = "enrollment-dashboard/x/modify-benefit",
//     EnrollmentDashboardXWaiveBenefit = "enrollment-dashboard/x/waive-benefit",
//     EnrollmentDashboardXKeepCurrentElections = "enrollment-dashboard/x/keep-current-elections",
//     EnrollmentDashboardXCancelRequest = "enrollment-dashboard/x/cancel-request",
//     CounselorCarrierInfo = "counselor/carrier-info",
//     CounselorEditAgents = "counselor/edit-agents",
//     CustomerRelationsMemberActivityLogDetail = "customer-relations/member-activity-log/detail",
//     CustomerRelationsMemberActivityLogHistory = "customer-relations/member-activity-log/history",
//     CustomerRelationsMemberFollowUpOpen = "customer-relations/member-follow-up/open",
//     EnrollmentDashboardXTermBenefit = "enrollment-dashboard/x/term-benefit",
//     EnrollmentDashboardXFsaReenroll = "enrollment-dashboard/x/fsa-reenroll",
//     EnrollmentDashboardXWidget = "enrollment-dashboard/x/widget",
//     EnrollmentDashboardCheckout = "enrollment-dashboard/checkout",
//     EnrollmentDashboardXWaiveCoverage = "enrollment-dashboard/x/waive-coverage",
//     CheckoutComplete = "checkout-complete",
//     DependentVerification = "dependent-verification",
//     LifeEventVerification = "life-event-verification",
//     CheckoutCompleteNewhire = "checkout-complete/newhire",
//     ChekcoutCompleteYearround = "chekcout-complete/yearround",
//     BenefitsBenefitSummary = "benefits/benefit-summary",
//     CounselorMemberConfirm = "counselor/member-confirm",
//     CounselorCallLog = "counselor/call-log",
//     CounselorCallLogDetail = "counselor/call-log-detail",
//     CounselorReports = "counselor/reports",
//     CounselorCompanyResources = "counselor/company-resources",
//     CounselorCustomerRelationsMemberActivityLogHistory = "counselor/customer-relations/member-activity-log/history",
//     CounselorCustomerRelationsMemberActivityLogDetail = "counselor/customer-relations/member-activity-log/detail",
//     CounselorMemberLookup = "counselor/member-lookup",
//     CounselorLookupHistory = "counselor/lookup-history",
//     CounselorTestMembers = "counselor/test-members",
//     CounselorCreateMember = "counselor/create-member",
//     CounselorFollowUps = "counselor/follow-ups",
//     CounselorFollowUpDetail = "counselor/follow-up-detail",
//     CounselorCustomerRelationsMemberFollowUpDetail = "counselor/customer-relations/member-follow-up/detail",
//     CounselorCompletedFollowUps = "counselor/completed-follow-ups",
//     CounselorFollowUpManagement = "counselor/follow-up-management",
//     MemberAccountingAccountTransactions = "member-accounting/account-transactions",
//     MemberAccountingBenefitTransactions = "member-accounting/benefit-transactions",
//     CounselorCustomerRelationsMemberFollowUpOpen = "counselor/customer-relations/member-follow-up/open",
//     CounselorCustomerRelationsMemberFollowUpCompleted = "counselor/customer-relations/member-follow-up/completed",
//     CounselorCustomerRelationsMemberFollowUpManagement = "counselor/customer-relations/member-follow-up/management",
//     CounselorReportBuilderX = "counselor/report-builder/x",
//     WidgetAddDependent = "widget-add-dependent",
//     CounselorBenefitLevel = "counselor/benefit-level",
//     CounselorCompanyLevel = "counselor/company-level",
//     CounselorCompliance = "counselor/compliance",
//     CustomerRelationsMemberFollowUpCompleted = "customer-relations/member-follow-up/completed",
//     CustomerRelationsMemberFollowUpDetail = "customer-relations/member-follow-up/detail",
//     ProfileDeleteMember = "profile/delete-member",
//     CounselorContacts = "counselor/contacts",
//     EnrollmentPendingEoi = "enrollment/pending-eoi",
//     EnrollmentBenefitSummary = "enrollment/benefit-summary",
//     EnrollmentDependentVerification = "enrollment/dependent-verification",
//     EnrollmentBeneficiaries = "enrollment/beneficiaries",
//     EnrollmentAvailableEnrollments = "enrollment/available-enrollments",
//     EnrollmentBenefitsDashboards = "enrollment/benefits-enrollments",
//     EnrollmentCurrentAndPendingBenefits = "enrollment/current-and-pending-benefits",
//     EnrollmentBenefitRequests = "enrollment/benefit-requests",
//     EnrollmentLifeEventRequest = "enrollment/life-event-request",
//     EnrollmentLifeEventRequestNotes = "enrollment/life-event-request/notes",
//     CounselorReportsTodaysReports = "counselor/reports/todays-reports",
//     CounselorReportsHistory = "counselor/reports/history",
//     CounselorManageAgents = "counselor/manage-agents",
//     CounselorCompanyAssign = "counselor/company-assign",
//     CounselorAgentAssign = "counselor/agent-assign",
//     PaymentInformation = "benefits/payment-information",
// }

export enum ContentHeaderTitle {
    contentHeaderDashboard = "Dashboard",
    contentHeaderProfileMember = "Member",
    contentHeaderProfileDependents = "Dependents",
    contentHeaderBenefitsCurrentBenefits = "Current Benefits",
    contentHeaderBenefitsEnrollmentRequests = "Enrollment Requests",
    contentHeaderBenefitsBenefitsAtRenewal = "Benefits At Renewal",
    contentHeaderBenefitsPendingEoi = "Pending E.O.I.",
    contentHeaderBeneficiaries = "Beneficiaries",
    contentHeaderDocumentsBenefits = "Benefits",
    contentHeaderDocumentsCompany = "Company",
    contentHeaderDocumentsCompliance = "Compliance",
    contentHeaderDocumentsContacts = "Contacts",
    contentHeaderDocumentsForm1095 = "Form 1095s",
    contentHeaderDocumentsW2 = "W2s",
    contentHeaderEnrollment = "Enrollment Setup",
    contentHeaderEnrollmentDashboardX = "xxxx",
    contentHeaderEnrollmentDashboardXAddBenefit = "Add Benefit",
    contentHeaderEnrollmentDashboardXReplaceBenefit = "Replace Benefit",
    contentHeaderEnrollmentDashboardXModifyBenefit = "Modify Benefit",
    contentHeaderEnrollmentDashboardXWaiveBenefit = "Waive Benefit",
    contentHeaderEnrollmentDashboardXKeepCurrentElections = "Keep Current Elections",
    contentHeaderEnrollmentDashboardXCancelRequest = "Cancel Request(s)",
    contentHeaderCounselorCarrierInfo = "Carrier Information",
    contentHeaderCounselorEditAgents = "Edit Agents",
    contentHeaderCustomerRelationsMemberActivityLogDetail = "Create Activity Log",
    contentHeaderCustomerRelationsMemberActivityLogHistory = "Activity Log History",
    contentHeaderCustomerRelationsMemberFollowUpOpen = "Open Follow Ups",
    contentHeaderEnrollmentDashboardXTermBenefit = "Term Benefit",
    contentHeaderEnrollmentDashboardXFsaReenroll = "FSA Reenroll",
    contentHeaderEnrollmentDashboardXWidget = "Add Benefit",
    contentHeaderEnrollmentDashboardCheckout = "Checkout Process",
    contentHeaderEnrollmentDashboardXWaiveCoverage = "Waive Coverage",
    contentHeaderCheckoutComplete = "Checkout Completed!",
    contentHeaderDependentVerification = "Dependent Verification",
    contentHeaderLifeEventVerification = "Life Event Verification",
    contentHeaderCheckoutCompleteNewhire = "Checkout Completed!",
    contentHeaderChekcoutCompleteYearround = "Checkout Completed!",
    contentHeaderBenefitsBenefitSummary = "Benefit Summaries",
    contentHeaderCounselorMemberConfirm = "Member Confirmation",
    contentHeaderCounselorCallLog = "Call Log",
    contentHeaderCounselorCallLogDetail = "Create Call Log",
    contentHeaderCounselorReports = "Reports",
    contentHeaderCounselorCompanyResources = "Company Resources",
    contentHeaderCounselorCustomerRelationsMemberActivityLogHistory = "Member Activity Log",
    contentHeaderCounselorCustomerRelationsMemberActivityLogDetail = "Member Activity Log",
    contentHeaderCounselorMemberLookup = "Member Lookup",
    contentHeaderCounselorLookupHistory = "Lookup History",
    contentHeaderCounselorTestMembers = "Test Members",
    contentHeaderCounselorCreateMember = "Create Member",
    contentHeaderCounselorFollowUps = "Follow Ups",
    contentHeaderCounselorFollowUpDetail = "Follow Up Detail",
    contentHeaderCounselorCustomerRelationsMemberFollowUpDetail = "Member Follow Up Detail",
    contentHeaderCounselorCompletedFollowUps = "Completed Followups",
    contentHeaderCounselorFollowUpManagement = "Followup Management",
    contentHeaderMemberAccountingAccountTransactions = "Account Transactions",
    contentHeaderMemberAccountingBenefitTransactions = "Account Transactions",
    contentHeaderCounselorCustomerRelationsMemberFollowUpOpen = "Open Followup Items",
    contentHeaderCounselorCustomerRelationsMemberFollowUpCompleted = "Completed Followup Items",
    contentHeaderCounselorCustomerRelationsMemberFollowUpManagement = "Followup Management",
    contentHeaderCounselorReportBuilderX = "Run Report",
    contentHeaderWidgetAddDependent = "Add Dependent",
    contentHeaderCounselorBenefitLevel = "Benefit Resources",
    contentHeaderCounselorCompanyLevel = "Company Resources",
    contentHeaderCounselorCompliance = "Compliance Resources",
    contentHeaderCustomerRelationsMemberFollowUpCompleted = "Completed Follow Ups",
    contentHeaderCustomerRelationsMemberFollowUpDetail = "Follow Up Detail",
    contentHeaderProfileDeleteMember = "ACCOUNT DELETION NOTICE",
    contentHeaderCounselorContacts = "Contacts Resources",
    contentHeaderEnrollmentPendingEoi = "Pending E.O.I",
    contentHeaderEnrollmentBenefitSummary = "Benefit Summaries",
    contentHeaderEnrollmentDependentVerification = "Dependent Verification",
    contentHeaderEnrollmentBeneficiaries = "Beneficiaries",
    contentHeaderEnrollmentAvailableEnrollments = "Available Enrollments",
    contentHeaderEnrollmentBenefitsDashboard = "Benefits Dashboard",
    contentHeaderEnrollmentCurrentAndPendingBenefits = "My Benefits",
    contentHeaderEnrollmentBenefitRequests = "Change Requests",
    contentHeaderEnrollmentLifeEventRequest = "Life Event Request",
    contentHeaderEnrollmentLifeEventRequestNotes = "Notes",
    contentHeaderCounselorReportsTodaysReports = "Todays Reports",
    contentHeaderCounselorReportsHistory = "Report History",
    contentHeaderCounselorManageAgents = "Agents",
    contentHeaderCounselorCompanyAssign = "Company Assignment",
    contentHeaderCounselorAgentAssign = "Agent Assignment",
    contentHeaderPaymentInformation = "Payment Information",
    contentHeaderAccountTransactions = "Account Transactions",
    contentHeaderPayrollAddress = "Address Information",
    contentHeaderPayrollDeductions = "Deductions",
    contentHeaderPayrollStateTaxDetails = "State Tax Details",
    contentHeaderPayrollFederalTaxDetails = "Federal Tax Details",
    contentHeaderPayrollPTOSickHours = "PTO / Sick Hours",
    contentHeaderPayrollAnnualStatements = "Annual Statements",
    contentHeaderPayrollPayStubs = "Pay Stubs",
    contentHeaderPayrollDirectDeposit = "Direct Deposit",
    contentHeaderPayrollDashboard = "Payroll Dashboard",
    contentHeaderAvailableBenefits = "Available Benefits"
}

export enum ContentHeaderHTML {
    contentHeaderHTMLProfileMember = "",
    contentHeaderHTMLProfileDependents = "",
    contentHeaderHTMLBenefitsCurrentBenefits = "<div class= \"message-card\">Note: Benefit plans which cover groups of family members, i.e. “all eligible children,” may not list covered family members individually.</div>",
    contentHeaderHTMLBenefitsEnrollmentRequests = "<div class= \"message-card\">Note: Benefit plans which cover groups of family members, i.e. “all eligible children,” may not list covered family members individually.</div>",
    contentHeaderHTMLBenefitsBenefitsAtRenewal = "<div class= \"message-card\">Note: Benefit plans which cover groups of family members, i.e. “all eligible children,” may not list covered family members individually.</div>",
    contentHeaderHTMLBenefitsPendingEoi = "<div class= \"message-card\">Note: Benefit plans which cover groups of family members, i.e. “all eligible children,” may not list covered family members individually.</div>",
    contentHeaderHTMLBeneficiaries = "<div class=\"message-card\"> Note: Beneficiaries are maintained at the benefit level.At least one “Primary” beneficiary should be designated for each benefit.Percentages for beneficiaries must add up to 100%.Only primary beneficiaries are required.Contingent beneficiaries are optional, but if selected, must also total 100 %.</div>",
    contentHeaderHTMLDocumentsBenefits = "",
    contentHeaderHTMLDocumentsCompany = "",
    contentHeaderHTMLDocumentsCompliance = "",
    contentHeaderHTMLDocumentsContacts = "<div class= \"message-card\">Note: Should you need assistance from a carrier or vendor not listed, contact your human resource or benefits department for assistance.</div>",
    contentHeaderHTMLDocumentsForm1095 = "",
    contentHeaderHTMLDocumentsW2 = "",
    contentHeaderHTMLEnrollment = "",
    contentHeaderHTMLEnrollmentDashboardX = "",
    contentHeaderHTMLEnrollmentDashboardXAddBenefit = "",
    contentHeaderHTMLEnrollmentDashboardXReplaceBenefit = "",
    contentHeaderHTMLEnrollmentDashboardXModifyBenefit = "",
    contentHeaderHTMLEnrollmentDashboardXWaiveBenefit = "<div class= \"message-card\">Note: waiving benefits within this category may forfeit your ability to obtain these benefits in the future without a Qualified Life Event (QLE).</div> <p>Once you have submitted your benefit request, you will be prompted to continue with the enrollment process, or if applicable, proceed to the checkout section.</p>",
    contentHeaderHTMLEnrollmentDashboardXKeepCurrentElections = "",
    contentHeaderHTMLEnrollmentDashboardXCancelRequest = "",
    contentHeaderHTMLEnrollmentDashboardXTermBenefit = "",
    contentHeaderHTMLEnrollmentDashboardXFsaReenroll = "",
    contentHeaderHTMLEnrollmentDashbardXWidget = "",
    contentHeaderHTMLEnrollmentDashboardCheckout = "",
    contentHeaderHTMLEnrollmentDashboardXWaiveCoverage = "<div class= \"message-card\">Note: if there are guarantee issue offers for benefits within this category you may be forfeiting your ability to obtain these benefits in the future without providing evidence of insurability (EOI) and being subject to carrier/vendor underwriting approval.</div>",
    contentHeaderHTMLCheckoutComplete = "",
    contentHeaderHTMLDependentVerification = "",
    contentHeaderHTMLLifeEventVerification = "<div class= \"message-card\">Note: If you have already uploaded documents during your QLE enrollment session, there is no need to upload your documentation again.</div>",
    contentHeaderHTMLCheckoutCompleteNewhire = "",
    contentHeaderHTMLChekcoutCompleteYearround = "",
    contentHeaderHTMLBenefitsBenefitSummary = "",
    contentHeaderHTMLCounselorMemberConfirm = "",
    contentHeaderHTMLCounselorCallLog = "",
    contentHeaderHTMLCounselorCallLogDetail = "",
    contentHeaderHTMLCounselorCompanyResources = "<div class= \"message-card\">Note: you will only have access to companies for which you have been granted access.</div>",
    contentHeaderHTMLCounselorCustomerRelationsMemberActivityLogHistory = "",
    contentHeaderHTMLCounselorMemberLookup = "<div class= \"message-card\">Note: You can only search for employees in companies you have access to. Please contact your account manager if you need help accessing employees in a certain company.</div>",
    contentHeaderHTMLCounselorLookupHistory = "<div class= \"message-card\">Note: These include both ACTIVE and TEST employees you have looked up.</div>",
    contentHeaderHTMLCounselorTestMembers = "<div class= \"message-card\">Note: You can only search for employees in companies you have access to. Please contact your account manager if you need help accessing employees in a certain company.</div>",
    contentHeaderHTMLCounselorCreateMember = "<div class= \"message-card\">Note: This function is only used if a company allows it. If an employee needs to be added to a specific company and you are not able to do so here, please contact your company representative to assist you.</div",
    contentHeaderHTMLCounselorFollowUps = "",
    contentHeaderHTMLCounselorFollowUpDetail = "",
    contentHeaderHTMLCounselorCompletedFollowUps = "<div class= \"message-card\">Note: You can filter follow ups by date range with the Date Range drop down below.</div>",
    contentHeaderHTMLCounselorFollowUpManagement = "",
    contentHeaderHTMLCounselorBenefitLevel = "<div class= \"message-card\">Note: You will only be able to see the resources of the companies you have access to.</div>",
    contentHeaderHTMLCounselorCompanyLevel = "<div class= \"message-card\">Note: You will only be able to see the resources of the companies you have access to.</div>",
    contentHeaderHTMLCounselorCompliance = "<div class= \"message-card\">Note: You will only be able to see the resources of the companies you have access to.</div>",
    contentHeaderHTMLCounselorContacts = "<div class= \"message-card\">Note: You will only be able to see the resources of the companies you have access to.</div",
    contentHeaderHTMLCounselorManageAgents = "",
    contentHeaderHTMLEnrollmentPendingEoi = "<div class= \"message-card\">Note: Benefit plans which cover groups of family members, i.e. “all eligible children,” may not list covered family members individually.</div>",
    contentHeaderHTMLEnrollmentBenefitSummary = "",
    contentHeaderHTMLEnrollmentDependentVerification = "",
    contentHeaderHTMLEnrollmentBeneficiaries = "<div class= \"message-card\">Note: Beneficiaries are maintained at the benefit level. At least one “Primary” beneficiary should be designated for each benefit. Percentages for beneficiaries must add up to 100%. Only primary beneficiaries are required. Contingent beneficiaries are optional, but if selected, must also total 100%.</div>",
    contentHeaderHTMLEnrollmentAvailableEnrollments = "",
    contentHeaderHTMLEnrollmentBenefitsDashboard = "",
    contentHeaderHTMLEnrollmentCurrentAndPendingBenefits = "<div class= \"message-card\">Note: Benefit plans which cover groups of family members, i.e. “all eligible children,” may not list covered family members individually.</div>",
    contentHeaderHTMLEnrollmentBenefitRequests = "",
    contentHeaderHTMLEnrollmentLifeEventRequest = "",
    contentHeaderHTMLEnrollmentLifeEventRequestNotes = "",
    contentHeaderHTMLPaymentInformation = "",
    contentHeaderHTMLPayrollAddress = "",
    contentHeaderHTMLPayrollDeductions = "",
    contentHeaderHTMLPayrollStateTaxDetails = "",
    contentHeaderHTMLPayrollFederalTaxDetails = "",
    contentHeaderHTMLPayrollPTOSickHours = "",
    contentHeaderHTMLPayrollAnnualStatements = "",
    contentHeaderHTMLPayrollPayStubs = "",
    contentHeaderHTMLPayrollDirectDeposit = "",
    contentHeaderHTMLPayrollDashboard = "",
}